import { render, staticRenderFns } from "./websocket.vue?vue&type=template&id=d70626c6"
import script from "./websocket.vue?vue&type=script&lang=js"
export * from "./websocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports